<template>
  <section>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Visit Status
        </p>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-form
          ref="form"
          v-model="valid"
        >
          <div class="checkout-details">
            <v-radio-group
              v-model="visitStatus"
              row
              :rules="[(v) => !!v || 'This field is required']"
              class="field-text-style"
              light
              @change="isVisitStatusChanged"
            >
              <v-radio
                label="Pending"
                value="pending"
                light
                color="#37474F"
              >
                <template #label>
                  <span class="input__label">Pending</span>
                </template>
              </v-radio>
              <v-radio
                label="Completed"
                value="completed"
                light
                color="#37474F"
              >
                <template #label>
                  <span class="input__label">Completed</span>
                </template>
              </v-radio>
            </v-radio-group>
            <v-textarea
              ref="status"
              v-model="pendingReason"
              dense
              :rules="visitStatus === 'pending' ? [(v) => !!v || 'This field is required'] : []"
              filled
              persistent-hint
              color="#37474F"
              class="field-text-style"
              background-color="transparent"
              light
              :disabled="visitStatus !== 'pending'"
              outlined
              label="Visit Status"
            />
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <v-btn
      color="000"
      class="mt-5 btn-style"
      elevation="0"
      @click="visitStatusGathered()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'GatherVisitStatus',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      arrangePretty (val) {
        return val.join(', ');
      },
    },
    data: () => ({
      loading: false,
      valid: false,
      visitStatus: null,
      pendingReason: null,
    }),
    methods: {
      visitStatusGathered () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        this.$store.dispatch('swiftuser/saveVisitStatus', {
          visit_status: this.visitStatus,
          pending_reason: this.pendingReason,
        });
        setTimeout(() => {
          this.loading = false;
          this.$emit('visit-status-stored');
        }, 1000);
      },
      isVisitStatusChanged () {
        if (this.visitStatus === 'completed') {
          this.$refs.status.reset();
        }
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckOut' });
        }, 1000);
      },
    },
  };
</script>
<style scoped>
.checkin .mdi-checkbox-marked::before{
  color: #37474F !important;
  caret-color: #37474F !important;
}
::v-deep .v-input--selection-controls__input .v-icon {
  color: #37474F !important;
}
</style>
